// Gecko surfaces native failures as XPCOM nsIException objects rather than Errors. Our own code
// never throws one, so every instance is an injected extension script or a blocked platform API.
// Matches the nsresult code instead of the NS_ERROR_FAILURE label, which some messages omit.
export const XPCOM_EXCEPTION = /nsresult:\s*"0x80004005/i;
